const STATUSES = {
  INVITED: { id: 1, name: 'invited' },
  ACCEPTED: { id: 2, name: 'accepted' },
  REJECTED: { id: 3, name: 'rejected' },
  CANCELED: { id: 4, name: 'canceled' },
};

export default STATUSES;
